module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_10.f47c7499.png";